import React from "react";

function Share_post({id,title,image}){
    return(
        <div className="share-post">
            <h3>اشتراک گذاری مقاله :</h3>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=https://baghban.resturant/blog/post/${id}`} target="_blank">
                <i className="fab fa-facebook"></i>
            </a>
            <a href={`https://twitter.com/share?url=https://baghban.resturant/blog/post/${id}&text=${title}`} target="_blank">
                <i className="fab fa-twitter"></i>
            </a>
            <a href={`https://pinterest.com/pin/create/button/?url=https://baghban.resturant/blog/post/${id}&media=${image}`} target="_blank">
                <i className="fab fa-pinterest"></i>
            </a>
            <a href={`https://api.whatsapp.com/send?text=https://baghban.resturant/blog/post/${id}`} target="_blank">
                <i className="fab fa-whatsapp"></i>
            </a>
        </div>
    );
}

export default Share_post;